import React from 'react';
import { Modal } from 'antd';
import { ButtonCommon } from 'components/common';
import { WarningCircle, CheckCircle, Info, Trash } from '@phosphor-icons/react';
import { ConfirmationModalProps } from 'types/modal.type';
const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
  title,
  subtitle,
  icon = 'warning',
  confirmText = 'Đồng Ý',
  cancelText = 'Hủy',
  confirmLoading = false,
}) => {
  const getIcon = () => {
    const size = 32;

    switch (icon) {
      case 'success':
        return <CheckCircle size={size} weight='fill' color='var(--sematicSuccessColor)' />;
      case 'error':
        return <WarningCircle size={size} weight='fill' color='var(--sematicErrorColor)' />;
      case 'info':
        return <Info size={size} weight='fill' color='var(--sematicInfoColor)' />;
      case 'delete':
        return <Trash size={size} color='var(--sematicErrorColor)' />;
      case 'warning':
      default:
        return <WarningCircle size={size} weight='fill' color='var(--sematicWarningColor)' />;
    }
  };

  return (
    <Modal
      open={isOpen}
      // onCancel={onCancel}
      footer={null}
      width={500}
      centered
      closeIcon={false}
      className='modal-none-padding'
    >
      <div className='p-6 bg-white rounded-lg'>
        <div className='flex gap-4'>
          <div className='flex-shrink-0'>{getIcon()}</div>

          <div className='flex-1'>
            <h3 className='text-[20px] font-bold leading-[24px] text-[var(--opacityTextColor)]'>{title}</h3>
            <div className='text-[14px] leading-[20px] text-[var(--opacityTextColor)] !mt-2'>{subtitle}</div>
          </div>
        </div>

        <div className='flex justify-end gap-2 mt-6'>
          <ButtonCommon color='none' radius='rounded' onClick={onCancel}>
            {cancelText}
          </ButtonCommon>

          <ButtonCommon color='primary' radius='rounded' onClick={onConfirm} loading={confirmLoading}>
            {confirmText}
          </ButtonCommon>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
